import { QualifyingAdverb } from '../../types'

const охуенно: QualifyingAdverb = {
  type: 'qualifying adverb',
  adverb: 'охуенно',
  comparative: 'охуеннее',
  superlative: 'охуенней',
}

export default охуенно
